'use client';

import { css } from '@flipster/styled-system/css';

import RewardHubImageBanner from './banner/image';
import { TotalRewardBanner } from './banner/total-reward';
import Rules from './rules';
import { SectionList } from './section-list';

const WelcomePackage = () => {
  return (
    <section className={css({ pb: { base: 40, smallDesktop: 128 } })}>
      <RewardHubImageBanner />
      <TotalRewardBanner />
      <SectionList />
      <Rules />
    </section>
  );
};

export default WelcomePackage;
